import { Navigate, Outlet } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";
import { useAuthStatus } from "@mirage/hooks/useAuthStatus";

interface ProtectedRouteProps {
    redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ redirectTo }) => {
    const { loggedIn, checkingStatus } = useAuthStatus();
    if (checkingStatus) {
        return (
            <Backdrop sx={{ color: "#fff" }} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }
    return loggedIn ? <Outlet /> : <Navigate to={redirectTo ? redirectTo : "/"} />;
};
